import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiDownload } from 'react-icons/fi';

const TaxesToGoSection = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  return (
    <section className="py-20 bg-gray-50" ref={ref}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="order-1 md:order-1"
          >
            <img 
              src="https://cdn.prod.website-files.com/64d13f6ce094cf9b34b8f52f/64d54d1bf1f5d52420385a6d_Taxes%20To%20Go%20cutout.png" 
              alt="Taxes To Go App" 
              className="mx-auto max-w-full shadow-lg rounded-lg"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="order-2 md:order-2"
          >
            <h2 className="text-3xl font-bold mb-6">Download Taxes-To-Go App</h2>
            <p className="text-gray-700 mb-8">
              Available on Apple or Google Play Store. Sign-in, upload PDFs &/or pictures of tax documents, secure chat available, & electronically sign documents all within the app. Everything will be imported into our software.
              <br /><br />
              If you are given a message to share a code with us after completing the submission of your documents, please forward the code & your email address used to sign-up by calling/texting (870) 208-4089 with that information. If you need any assistance please give us a call.
            </p>
            <a 
              href="https://taxestogo.com/App/Download/54705" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
            >
              <FiDownload className="mr-2" />
              <span>Get Started</span>
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TaxesToGoSection;